// extracted by mini-css-extract-plugin
module.exports = {"loading-indicator":"LoadingIndicator_loading-indicator__9jjTv"};